import { loader } from 'graphql.macro'

export default function ticketTypes ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const ticketTypesSchema = loader('./ticketTypes.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(ticketTypesSchema, {
    haulerId: variables.haulerId,
    status: variables.status
  })
}
